interface HeartbeatTimeFormatOptions {
  locale?: string | string[];
  timeZone?: string;
}

function buildFormatterOptions(
  options: Intl.DateTimeFormatOptions,
  overrides?: HeartbeatTimeFormatOptions,
): Intl.DateTimeFormatOptions {
  return overrides?.timeZone
    ? { ...options, timeZone: overrides.timeZone }
    : options;
}

export function formatHeartbeatNextFire(
  iso: string,
  overrides?: HeartbeatTimeFormatOptions,
): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }

  return new Intl.DateTimeFormat(
    overrides?.locale,
    buildFormatterOptions(
      {
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
      },
      overrides,
    ),
  ).format(date);
}

export function formatHeartbeatTriggerTime(
  createdAt: Date,
  overrides?: HeartbeatTimeFormatOptions,
): string {
  if (Number.isNaN(createdAt.getTime())) {
    return "Scheduled run";
  }

  const formattedTime = new Intl.DateTimeFormat(
    overrides?.locale,
    buildFormatterOptions(
      {
        hour: "2-digit",
        minute: "2-digit",
      },
      overrides,
    ),
  ).format(createdAt);

  return `Scheduled run at ${formattedTime}`;
}
